import React, { useState } from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { get } from 'lodash';
import EdgeStaticField from '../../../../EdgeControllersListPage/shared/components/EdgeStaticField/EdgeStaticField';
import EdgeFirmwareVersionField from '../../../../EdgeControllersListPage/shared/components/EdgeFirmwareVersionField/EdgeFirmwareVersionField';
import EdgeAssignmentField from '../../../../EdgeControllersListPage/shared/components/EdgeAssignmentField/EdgeAssignmentField';
import OnlineBadge from '../../../../../common/components/OnlineBadge/OnlineBadge';
import DemoEdgeReleaseNotesDialog from '../../../shared/dialogs/DemoEdgeReleaseNotesDialog/DemoEdgeReleaseNotesDialog';
import DemoEdgePlazaDetailsDialog from '../../../shared/dialogs/DemoEdgePlazaDetailsDialog/DemoEdgePlazaDetailsDialog';

function DemoEdgeControllerInfo({ edgeControllerId, currentEdgeControllerData = {} }) {
  const [releaseNotesDialogOpen, setReleaseNotesDialogOpen] = useState(false);
  const [plazaDialogOpen, setPlazaDialogOpen] = useState(false);

  const edgeControllerName = get(currentEdgeControllerData, 'name', 'N/A');
  const online = get(currentEdgeControllerData, 'online', false);
  const onlineTs = get(currentEdgeControllerData, 'onlineTs');
  const firmwareVersion = get(currentEdgeControllerData, 'firmwareVersion', 'N/A');
  const releaseNotes = get(currentEdgeControllerData, 'releaseNotes', null);
  const customerId = get(currentEdgeControllerData, 'customerId', 'N/A');
  const customerName = get(currentEdgeControllerData, 'customerName', 'N/A');
  const plazaId = get(currentEdgeControllerData, 'plazaId', 'N/A');
  const plazaName = get(currentEdgeControllerData, 'plazaName', 'N/A');

  const handleOpenReleaseNotes = () => {
    setReleaseNotesDialogOpen(true);
  };

  const handleCloseReleaseNotes = () => {
    setReleaseNotesDialogOpen(false);
  };

  const handleOpenPlazaDetails = () => {
    if (plazaId && plazaId !== 'N/A') {
      setPlazaDialogOpen(true);
    }
  };

  const handleClosePlazaDetails = () => {
    setPlazaDialogOpen(false);
  };

  return (
    <div className="details-tab-content">
      <Grid container justifyContent="center" spacing={2} style={{ padding: 16, backgroundColor: '#fff' }}>
        <Grid item xs={12} md={6} lg={4} className="edge-controller-details-section s-3">
          <Card style={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Basic Information
              </Typography>
              <EdgeStaticField label="Edge Controller ID" value={edgeControllerId} />
              <EdgeStaticField label="Edge Controller Name" value={edgeControllerName} />
              <OnlineBadge label="Online" online={online} timestamp={onlineTs} showTimestamp />
              <EdgeFirmwareVersionField
                label="Firmware Version"
                value={firmwareVersion}
                releaseNotes={releaseNotes}
                onViewReleaseNotes={handleOpenReleaseNotes}
              />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} lg={4} className="edge-controller-details-section s-3">
          <Card style={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Assignment Information
              </Typography>
              <EdgeAssignmentField label="Customer ID" id={customerId} value={customerId} />
              <EdgeAssignmentField label="Customer Name" id={customerName} value={customerName} />
              <EdgeAssignmentField label="Plaza Name" id={plazaId} value={plazaName} onClick={handleOpenPlazaDetails} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <DemoEdgeReleaseNotesDialog open={releaseNotesDialogOpen} onClose={handleCloseReleaseNotes} releaseNotes={releaseNotes} />

      <DemoEdgePlazaDetailsDialog
        open={plazaDialogOpen}
        onClose={handleClosePlazaDetails}
        plazaId={plazaId !== 'N/A' ? plazaId : null}
        plazaName={plazaName !== 'N/A' ? plazaName : null}
        edgeControllerId={edgeControllerId}
      />
    </div>
  );
}

export default DemoEdgeControllerInfo;
